import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../clients/testerClient';

export const SIGNAL_AUDIT_LOGS_QUERY_KEY = 'query.signal.auditLogs';

export const useSignalAuditLogs = ({
  id,
  skip = 0,
  limit = 50,
  enabled = true,
}: {
  id: string | null;
  skip?: number;
  limit?: number;
  enabled?: boolean;
}) => {
  const result = useQuery({
    queryKey: [SIGNAL_AUDIT_LOGS_QUERY_KEY, id, skip, limit],
    queryFn: async () => {
      if (!id) {
        throw new Error('Signal ID is required');
      }
      return terraProxyApiClient.getSignalAuditLogs(id, skip, limit);
    },
    enabled: !!id && enabled,
    staleTime: 10000,
    refetchOnWindowFocus: false,
  });

  return {
    auditLogs: result.data?.logs ?? [],
    total: result.data?.total ?? 0,
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch,
  };
};
